import { getMidnightInTimezoneIsoString } from './date-helpers';

type SerializeRfiOptions = {
  dueDateTimeZone?: string;
};

/* eslint-disable class-methods-use-this */
export default class {
  // eslint-disable-next-line no-unused-vars
  serializeRfi(
    {
      dueDate: originalDueDate,
      assignedTo: originalAssignedTo,
      answer,
      officialResponse = answer,
      attachmentsAttributes,
      reserveCustomIdentifier,
      customIdentifier: originalCustomIdentifier,
      ...restAttributes
    }: any,
    options: SerializeRfiOptions = {},
  ) {
    const { dueDateTimeZone } = options;
    const serializedAttachmentsAttributes = attachmentsAttributes
      ? attachmentsAttributes.map(({ urn_type: urnType, ...rest }: any) => ({
          urnType,
          ...rest,
        }))
      : undefined;

    const deleteDueDate = originalDueDate === null;
    const dueDate = deleteDueDate
      ? null
      : getMidnightInTimezoneIsoString(originalDueDate, dueDateTimeZone);
    const deleteCustomIdentifier = originalCustomIdentifier === '';
    const customIdentifier = deleteCustomIdentifier
      ? null
      : originalCustomIdentifier || reserveCustomIdentifier;

    return {
      ...restAttributes,
      attachmentsAttributes: serializedAttachmentsAttributes,
      assignedTo: originalAssignedTo || undefined,
      officialResponse,
      customIdentifier,
      dueDate,
    };
  }
}
